// The product's name and the one-line ways it describes itself.
//
// Why this file exists: "TaskPogo" was spelled out inline in ~35 places across
// the landing page, the nav, the legal pages and the in-app help. Centralizing
// the rendered English means a future rename is this file plus the short,
// explicit list below -- rather than a grep that has to sort product copy from
// resource identifiers by eye.
//
// It lives in fleet-shared, beside Urls.mjs, because that is where dual-runtime
// constants live: a Lambda can import it by relative path if one ever needs to.
//
// ---------------------------------------------------------------------------
// WHAT A RENAME STILL HAS TO TOUCH BY HAND, and why each one cannot read this:
//
//   public/index.html        static HTML; CRA substitutes only %PUBLIC_URL%.
//                            (title, description, og:*, twitter:*)
//   public/manifest.json     static JSON.
//   public/sitemap.xml       hardcoded absolute URLs.
//   email/*.txt              SES template JSON. SES renders a strict Handlebars
//                            subset with NO helpers, so a constant cannot be
//                            injected -- it would have to become a payload
//                            field on every renderer.
//   amplify/backend.ts       sesIdentityArns / sesTemplateArns are verified AWS
//                            identities. Renaming is a resource replacement.
//   amplify/auth/resource.ts fromName / fromEmail: SES identity facts.
//   weather-proxy/handler    the User-Agent string NWS requires. A contract
//                            with an external service, not copy.
//
// Deliberately NOT routed through here even though they render as English:
//
//   LogbookIO.mjs / TripIO.mjs -- "This file is not a TaskPogo logbook export."
//   The adjacent check is on a format marker written into every export FILE.
//   Templating the message while the marker stays fixed would, after a rename,
//   produce "not a Foo export" about a file whose marker still says taskpogo.
//
//   Navigation.jsx's `www.taskpogo.com` hostname check -- that is a deploy
//   environment test, not a name.
//
//   All TaskPogo* GraphQL model names and the TaskPogoUsers group -- renaming
//   any of them is a data migration (see scripts/MIGRATION_RUNBOOK.md).
// ---------------------------------------------------------------------------

export const PRODUCT_NAME = 'TaskPogo';

// The hero sub-headline. Leads with the boat and closes on everything else,
// deliberately in one breath: the non-boat commitment belongs in the hero, not
// eight scrolls down.
export const PRODUCT_TAGLINE =
  `${PRODUCT_NAME} plans your boat trips leg by leg, brings you marine ` +
  'forecasts, tides and currents along the route, and keeps your ' +
  "Captain's Log — plus the maintenance tasks and logbook that keep her " +
  'running. It works the same way for an airplane, a house, or a car.';

// Meta-description length. Kept separate from the tagline because this one is
// read by crawlers and link-preview cards, where the hero's em-dash prose reads
// badly and the character budget is real.
export const PRODUCT_SHORT_DESCRIPTION =
  'Plan boat trips leg by leg with a route map, marine weather, tides and ' +
  "currents. Keep a Captain's Log, track maintenance by date or engine " +
  'hours, and get a daily weather briefing for your trip.';

export const SUPPORT_EMAIL = 'info@taskpogo.com';

// Re-exported, never restated: Urls.mjs is where the domain lives and already
// builds every absolute URL from it.
export { siteUrl as SITE_URL } from './Urls.mjs';
